$(document).ready(function(){

  // var url = "http://192.168.0.13:50001"
  var url = "https://mail.confortenergies.bakasable.fr"

  var openHour = 8
  var openMin = 30
  var startBreak = 12
  var endBreak = 14
  var closeHour = 17
  var closeMin = 30

  var date = new Date();

  if(date.getDay() === 5){
    closeMin = 0
  }

  $('#contact-phone').mask('00 00 00 00 00');

  $('.select').click(function(){
    $(this).toggleClass('open')
  }).mouseleave(function(){
    $(this).removeClass('open')
  })

  $('.select .options>div').click(function(){
    var val = $(this).children('p').text();
    $('.select input').val(val);
    $('#select').removeClass('red');
  })

  $("#email").blur(function(){
    var email = $('#email').val();
    var regexEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if(!regexEmail.test(email)){
      $(this).addClass('red')
    }else{
      $(this).removeClass('red')
    }
  })


  $("#contact-phone").blur(function(){
    var phone = $("#contact-phone").val();
    var regexPhone = /^(\d{2}\s){4}\d{2}$/;
    if(!regexPhone.test(phone) && phone !== ""){
      $(this).addClass("red")
    }else{
      $(this).removeClass('red')
    }
  })

  $("input[type=text]:not('#contact-phone'), textarea").blur(function(){
    $(this).removeClass('red')
    if($(this).val() !== ""){
      $(this).removeClass('red')
    }
  })


  $('.form .button').click(function(){

    var name = $('#name').val();
    var email = $('#email').val();
    var phone = $('#contact-phone').val();
    var select = $('#select').val();
    var message = $('#message').val();

    var regexEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    if(name === ''){
      $('.warn').text("Veuillez-indiquez votre nom et prénom.")
      setTimeout(function(){
        $('.warn').text('')
      },4000)
      $('#name').focus().addClass('red');
      return false;
    }else{
      $('.warn').text();
    }

    if(!regexEmail.test(email)){
      $('.warn').text("L'email indiqué n'est pas valide.")
      setTimeout(function(){
        $('.warn').text('')
      },4000)
      $('#email').focus().addClass('red');
      return false;
    }else{
      $('.warn').text();
    }


    if(select === ''){
      $('.warn').text("Veuillez-indiquez l'objet de l'email.")
      setTimeout(function(){
        $('.warn').text('')
      },4000)
      $('#select').addClass('red')
      return false;
    }else{
      $('.warn').text();
    }

    if(message === ''){
      $('.warn').text("Votre message est vide.")
      setTimeout(function(){
        $('.warn').text('')
      },4000)
      $('#message').focus().addClass('red');
      return false;
    }else{
      $('.warn').text();
    }

    var obj = {
      name,
      message,
      objet : select,
      email
    }

    var regexPhone = /^(\d{2}\s){4}\d{2}$/;
    if(regexPhone.test(phone)){
      obj.phone = phone
    }

    var date = new Date();


    if( date.getDay() === 6 || date.getDay() === 0 ||
    date.getHours() < openHour || (date.getHours() === openHour && date.getMinutes() < openMin) ||
    date.getHours() === closeHour && date.getMinutes() > closeMin ||
    startBreak <= date.getHours() && date.getHours() < endBreak
    ){
      obj.close = true
    }else{
      obj.close = false
    }

    $('.form .loader').addClass('show')
    $('.form .button').addClass('wait');

    $.ajax({
      type: "POST",
      url: url+'/mail',
      data: obj,
      success: function(res){
        if(res.message == 'Demande envoyé'){

          $('.warn').text('Message envoyé')
          $('#name').val('');
          $('#email').val('');
          $('#select').val('');
          $('#message').val('');

          $('.form .loader').removeClass('show')
          $('.form .button').removeClass('wait');

          setTimeout(function(){
            $('.warn').text('')
          },4000)
        }
      },
      error: function() {
        $('.warn').text("Le message n'a pas pu être envoyé.");
      }
    });

  })

})



// WEBPACK FOOTER //
// ./src/js/contact.js